import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import "./ResetPassword.css";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [sessionReady, setSessionReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase sends the recovery token in the URL hash.
    // The onAuthStateChange listener detects the PASSWORD_RECOVERY event.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") {
        setSessionReady(true);
      }
    });

    // Also check if we already have a session (in case the event fired before mount)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setSessionReady(true);
    });

    return () => subscription?.unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match. Please try again.");
      return;
    }

    setLoading(true);
    try {
      const { error: err } = await supabase.auth.updateUser({ password });
      if (err) throw err;
      setSuccess(true);
      // Redirect to home after 3 seconds
      setTimeout(() => navigate("/"), 3000);
    } catch (err) {
      setError(err?.message || "Failed to update password. The link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="resetPage">
      <div className="resetCard">
        {success ? (
          <div className="resetSuccess">
            <div className="resetSuccessIcon">✓</div>
            <h2>Password Updated!</h2>
            <p>Your password has been changed successfully. You can now sign in with your new password.</p>
            <p style={{ color: "#aaa", fontSize: "13px", marginTop: "16px" }}>Redirecting you to home...</p>
          </div>
        ) : (
          <>
            <div className="resetHeader">
              <h1>Set New Password</h1>
              <p>Enter a new password for your Ayrine account.</p>
            </div>

            {!sessionReady && (
              <div style={{ textAlign: "center", padding: "30px 0", color: "#888" }}>
                <p>Verifying your reset link...</p>
                <p style={{ fontSize: "13px", marginTop: "10px", color: "#aaa" }}>
                  If this takes too long, the link may have expired.
                  <br />Please request a new reset link.
                </p>
              </div>
            )}

            {sessionReady && (
              <form className="resetForm" onSubmit={handleSubmit}>
                {error && <p className="resetError">{error}</p>}

                <label className="resetLabel">New Password</label>
                <input
                  className="resetInput"
                  type="password"
                  required
                  placeholder="Minimum 6 characters"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <label className="resetLabel">Confirm New Password</label>
                <input
                  className="resetInput"
                  type="password"
                  required
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <button className="resetBtn" type="submit" disabled={loading}>
                  {loading ? "Updating..." : "Update Password"}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
